const TAB = {
    start: 1,
    questions: 2,
    results: 3,
}

Object.freeze(TAB)

export default TAB
